import { releaseFeatures } from "@/config/releaseFeatures";
import { FaBookOpen, FaRoute } from "react-icons/fa";

export const learningDestinations = releaseFeatures.learning ? [
  {
    href: "/learn",
    menuLabel: "learningNavigation.path",
    icon: FaRoute,
  },
  {
    href: "/learn/openings",
    menuLabel: "learningNavigation.lessons",
    icon: FaBookOpen,
  },
] as const : [{ href: "/learn/openings", menuLabel: "Openings", icon: FaBookOpen }] as const;

export function isLearningDestinationActive(href: string, pathname: string) {
  if (href === "/learn") return pathname === "/learn";
  return (
    pathname === "/learn/openings" ||
    pathname.startsWith("/learn/openings/") ||
    pathname === "/learn/lessons" ||
    pathname.startsWith("/learn/lessons/")
  );
}
